
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_im3vp_189",
  "refresh": "awsui_refresh_1r9lg_im3vp_189",
  "animating": "awsui_animating_1r9lg_im3vp_203",
  "resize-active": "awsui_resize-active_1r9lg_im3vp_219",
  "resize-side": "awsui_resize-side_1r9lg_im3vp_225",
  "resize-bottom": "awsui_resize-bottom_1r9lg_im3vp_228",
  "root": "awsui_root_1r9lg_im3vp_233",
  "preferences-button": "awsui_preferences-button_1r9lg_im3vp_244",
  "close-button": "awsui_close-button_1r9lg_im3vp_248",
  "drawer-closed": "awsui_drawer-closed_1r9lg_im3vp_259",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_im3vp_264",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_im3vp_284",
  "position-bottom": "awsui_position-bottom_1r9lg_im3vp_293",
  "position-side": "awsui_position-side_1r9lg_im3vp_318",
  "slider": "awsui_slider_1r9lg_im3vp_324",
  "slider-side": "awsui_slider-side_1r9lg_im3vp_352",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_im3vp_357",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_im3vp_368",
  "open-button": "awsui_open-button_1r9lg_im3vp_379",
  "open-button-side": "awsui_open-button-side_1r9lg_im3vp_383",
  "slider-icon": "awsui_slider-icon_1r9lg_im3vp_390",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_im3vp_396",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_im3vp_399",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_im3vp_403",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_im3vp_413",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_im3vp_416",
  "content-bottom": "awsui_content-bottom_1r9lg_im3vp_424",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_im3vp_435",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_im3vp_440",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_im3vp_444",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_im3vp_448",
  "content-side": "awsui_content-side_1r9lg_im3vp_453",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_im3vp_464",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_im3vp_467",
  "header": "awsui_header_1r9lg_im3vp_472",
  "header-text": "awsui_header-text_1r9lg_im3vp_481",
  "header-divider": "awsui_header-divider_1r9lg_im3vp_489",
  "header-actions": "awsui_header-actions_1r9lg_im3vp_495",
  "divider": "awsui_divider_1r9lg_im3vp_503",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_im3vp_508",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_im3vp_512",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_im3vp_515",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_im3vp_518",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_im3vp_522",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_im3vp_525",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_im3vp_528",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_im3vp_531",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_im3vp_534"
};
  